module.exports = __webpack_public_path__ + "img/23.ad9f83cf.png";